import { useAgentHold, setInvHold, useToast } from '@elva/ui';

/** Holding the Invisalign Coordinator (amendment 30 §3 → specs 36 + 37, shared store). */
export function useInvisHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('invisalign');
  const { toast } = useToast();
  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setInvHold(next);
      toast({
        title: next ? 'Invisalign Coordinator is on hold' : 'Invisalign Coordinator is working again — 2 held messages go at their next window',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
